<template>
  <div class>
    <v-card elevation="0" outlined v-if="!loading && games" min-height="350">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">skip_next</v-icon>
        <div class="d-flex flex-column" v-if="games[0]">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.nextMatchdayGames")}}</span>
          <span
            class="subheader-font body-2"
          >{{games[0].leagueName}}</span>
        </div>
        <div v-else class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.nextMatchdayGames")}}</span>
          <span
            class="subheader-font body-2"
          >{{$t("dashboards.placeholderNoGames")}}</span>
        </div>
      </v-card-title>
      <div v-if="!loading && !games[0]" class="d-flex justify-center align-center flex-column px-3 py-4 mb-13 text-center flex-grow-1">
        <v-icon color="primary lighten-5"  v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">event_busy</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderNextMatchDayNotFound")}}</span>
      </div>
      <div class="pr-3 pb-2">
        <div
          v-for="(game,index) in games"
          :key="index"
          class="body-2 pl-6 my-1 d-flex align-center"
        >
          <div class="w-11 text-center" v-if="$vuetify.breakpoint.mdAndUp">
            <span class="primary--text body-1">{{ game.matchDate.split(" ")[0] }}</span>
          </div>
          <router-link
            class="w-35 text-right d-flex align-center justify-end pr-1 primary--text body-1"
            :to="`/team/${game.homeTeamId}`"
          >
            <div>
              <v-img
                :src="game.homeTeamImgError ? 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png' : 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + game.homeTeamId + '.png'"
                :height="18"
                :width="18"
                class="mx-1"
                v-on:error="onImgError($event,game,'home')"
              />
            </div>
            <span>{{game.homeTeamName}}</span>
          </router-link>
          <div class="text-center font-weight-bold" v-bind:class="{'w-8':$vuetify.breakpoint.mdAndUp,'w-15':!$vuetify.breakpoint.mdAndUp}">
            <span></span>
            <span class="mx-1">-</span>
            <span></span>
          </div>
          <router-link
            class="w-35 d-flex align-center pl-1 primary--text body-1"
            :to="`/team/${game.awayTeamId}`"
          >
            <span>{{game.awayTeamName}}</span>
            <div>
              <v-img
                :src="game.awayTeamImgError ? 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png' : 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + game.awayTeamId + '.png'"
                :height="18"
                :width="18"
                class="mx-1"
                v-on:error="onImgError($event,game,'away')"
              />
            </div>
          </router-link>
          <div class="w-12">

          </div>
        </div>
      </div>
    </v-card>
    <v-card class="d-flex justify-center align-center py-8 px-12" v-if="loading">
      <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
    </v-card>
  </div>
</template>

<script>
import GameService from "../../../services/game/game.service";
import ResizeObserver from 'resize-observer-polyfill';

export default {
  name: "NextMatchdayGamesWidget",
  components: {
  },
  props: {
    seasonId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      games: null,
      loading: false,
      observer:null
    };
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
    this.observer = new ResizeObserver(this.onResize)
    .observe(this.$el)
  },
  methods: {
    async loadViewData() {
      await this.loadGames();
    },
    async loadGames() {
      this.loading = true;
      let gameResponse = await GameService.getNextMatchdayGames(
        this.seasonId
      );
      this.games = _.reverse(gameResponse.data);
      this.loading = false;
    },
    onImgError(event, item, side) {
      if (side === "home") {
        item.homeTeamImgError = true;
      } else if (side === "away") {
        item.awayTeamImgError = true;
      }
    },
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
  },
  destroyed () {
    delete this.observer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/NextMatchdayGamesWidget.vue